import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ContractAPIService } from 'src/app/extensions/services/api/contracts-api.service';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';
import { FilesHandler } from '../../client-data/utils/files-handler';
import { DictionaryContractType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';

@Component({
  selector: 'app-contract-modification-wizard',
  templateUrl: './contract-modification-wizard.component.html',
  styleUrls: ['./contract-modification-wizard.component.scss'],
  standalone: false,
})
export class ContractModificationWizardComponent implements OnInit {
  currentWizardStep: contractModificationsWizardSteps =
    contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
  public wizardStepsEnum = contractModificationsWizardSteps;

  featureLoaded: boolean = false;

  contractModificationRequest: app.models.ContractModificationRequest = {
    contractModificationRequestXDocuments: [] as app.models.RequestXDocument[],
    description: '',
  } as app.models.ContractModificationRequest;

  contractsDataSource: any[];
  contractModificationRequestType: app.models.DictionaryRequestTypeModel[];
  contractModificationPurposeDatasource: app.models.DictionaryContractModificationRequestPurpose[];

  DICTIONARY_CONTRACT_MODIFICATION_TYPE: app.models.DictionaryContractModificationRequestType =
    {} as app.models.DictionaryContractModificationRequestType;

  reimbursementTypeDatasource: app.models.DictionaryDataModel[];
  isDictionaryReimbursementTypeCached: boolean = false;

  contractModificationRequestReasonDatasource: app.models.DictionaryContractModificationRequestReason[];
  paymentSourcesDatasource: app.models.DictionaryDataModel[];
  description: string = '';
  otherModificationType: string;

  public firstQuestionFormGroup = new FormGroup({
    answear: new FormControl(),
    reason: new FormControl(),
  });

  postponedPeriodRange: { start: Date; end: Date };
  public secondQuestionFormGroup = new FormGroup({
    answear: new FormControl(),
  });

  public thirdQuestionFormGroup = new FormGroup({
    answear: new FormControl(),
  });

  public fourthQuestionFormGroup = new FormGroup({
    answear: new FormControl(),
  });
  dictionaryContractType: app.models.DictionaryDataModel;
  ContractType = DictionaryContractType;

  constructor(
    private _router: Router,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _contractAPIService: ContractAPIService,
    private _dictionaryAPIService: DictionaryAPIService,
    private _requestAPIService: RequestAPIService,
    private _activatedRoute: ActivatedRoute,
    public _fileHandler: FilesHandler
  ) {}

  ngOnInit(): void {
    this.contractModificationRequest.contractId = this._activatedRoute.snapshot.params['contractId'];
    this.loadData();
  }

  loadData() {
    this._contractAPIService.getActiveContracts().subscribe(x => {
      this.contractsDataSource = x;
      if (this.contractsDataSource.length === 1) {
        this.contractModificationRequest.contractId = this.contractsDataSource[0].contractId;
      }

      if (this.contractModificationRequest.contractId) {
        this.contractSelectHandler(this.contractModificationRequest.contractId);
      }
    });

    this._dictionaryAPIService.getDictionaryContractModificationRequestType().subscribe(x => {
      this.contractModificationRequestType = x;

      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT = this.contractModificationRequestType.find(
        x => x.code == 'RQST_REIMBURSEMENT'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL = this.contractModificationRequestType.find(
        x => x.code == 'RQST_INSTALLMENT_DEFERRAL'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER = this.contractModificationRequestType.find(
        x => x.code == 'RQST_OTHER'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER = this.contractModificationRequestType.find(
        x => x.code == 'RQST_FINANCING_OFFER'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS = this.contractModificationRequestType.find(
        x => x.code == 'RQST_COMPLAINTS'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT = this.contractModificationRequestType.find(
        x => x.code == 'RQST_CONTRACT_ASSIGNMENT'
      );
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT = this.contractModificationRequestType.find(
        x => x.code == 'RQST_DIRECT_DEBIT'
      );
    });

    this._dictionaryAPIService.getDictionaryPaymentSource(true).subscribe(x => {
      this.paymentSourcesDatasource = x;
    });

    this.featureLoaded = true;
  }

  contractModificationRequestHeader: app.models.ContractModificationRequestHeader;
  isContractSelected: boolean = false;
  contractSelectHandler = (contractId: string) => {
    this.contractModificationRequest.dictionaryModificationTypeId = undefined;
    this.contractModificationRequest.dictionaryReimbursementTypeId = undefined;

    this.firstQuestionFormGroup?.reset();
    this.secondQuestionFormGroup?.reset();
    this.thirdQuestionFormGroup?.reset();
    this.fourthQuestionFormGroup?.reset();

    this.isContractSelected = isNotEmpty(contractId);
    if (contractId) {
      this._requestAPIService.getContractModificationRequestHeader(contractId).subscribe(result => {
        this.contractModificationRequestHeader = result;
      });
    }
    this.dictionaryContractType = this.contractsDataSource.find(
      contract => contract.contractId === contractId
    )?.dictionaryContractType;
  };

  DICTIONARY_REIMBURSEMENT_TYPE: app.models.DictionaryReimbursementType = {} as app.models.DictionaryReimbursementType;
  contractModificationRequestTypeChangeHandler = (id: string) => {
    this.firstQuestionFormGroup.reset();
    this.secondQuestionFormGroup.reset();
    this.thirdQuestionFormGroup.reset();
    this.fourthQuestionFormGroup.reset();

    let selectedType = this.contractModificationRequestType.find(x => x.id === id);
    let populateOtherModificationType = [
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id,
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id,
      this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id,
    ];

    let contractId = this.contractModificationRequest.contractId;
    let modificationId = this.contractModificationRequest.dictionaryModificationTypeId;
    this.contractModificationRequest = {
      contractId: contractId,
      dictionaryModificationTypeId: modificationId,
      contractModificationRequestXDocuments: [],
      requestTypeDescription: this.contractModificationRequestType.find(x => x.id === id).description,
      description: '',
      otherModificationType: populateOtherModificationType.includes(id)
        ? selectedType?.value || selectedType?.description || null
        : null,
    } as app.models.ContractModificationRequest;
    if (
      id == this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id &&
      !this.isDictionaryReimbursementTypeCached
    ) {
      this._dictionaryAPIService.getDictionaryReimbursementType().subscribe(result => {
        this.reimbursementTypeDatasource = result;
        this.isDictionaryReimbursementTypeCached = true;

        this.DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT = this.reimbursementTypeDatasource.find(
          x => x.code == 'Full'
        );
        this.DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT = this.reimbursementTypeDatasource.find(
          x => x.code == 'Partial'
        );
      });
    }
  };

  contractModificationReimbursementTypeChangeHandler = () => {
    this.firstQuestionFormGroup.reset();
  };

  nextStepHandler = async (currentStep: contractModificationsWizardSteps, skippedStep: any = null) => {
    switch (currentStep) {
      case contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType:
        switch (this.contractModificationRequest.dictionaryModificationTypeId) {
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id:
            if (
              this.contractModificationRequest.dictionaryReimbursementTypeId ==
              this.DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id
            ) {
              this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Why;
            } else if (
              this.contractModificationRequest.dictionaryReimbursementTypeId ==
              this.DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id
            ) {
              this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Why;
            }
            break;

          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id:
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Why;
            break;

          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id:
            this.contractModificationRequest.contractName = this.contractsDataSource.find(
              x => x.contractId == this.contractModificationRequest.contractId
            )?.number;
            this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
              x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
            )?.value;
            this.otherModificationType = this.contractModificationRequest.otherModificationType;
            this.description = this.contractModificationRequest.description;
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id:
            this.contractModificationRequest.contractName = this.contractsDataSource.find(
              x => x.contractId == this.contractModificationRequest.contractId
            )?.number;
            this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
              x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
            )?.value;

            this.otherModificationType = this.contractModificationRequest.otherModificationType;
            this.description = this.contractModificationRequest.description;

            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id:
            this.contractModificationRequest.contractName = this.contractsDataSource.find(
              x => x.contractId == this.contractModificationRequest.contractId
            )?.number;
            this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
              x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
            )?.value;
            this.otherModificationType = this.contractModificationRequest.otherModificationType;
            this.description = this.contractModificationRequest.description;
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id:
            this.contractModificationRequest.contractName = this.contractsDataSource.find(
              x => x.contractId == this.contractModificationRequest.contractId
            )?.number;
            this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
              x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
            )?.value;
            this.otherModificationType = this.contractModificationRequest.otherModificationType;
            this.description = this.contractModificationRequest.description;
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id:
            this.contractModificationRequest.contractName = this.contractsDataSource.find(
              x => x.contractId == this.contractModificationRequest.contractId
            )?.number;
            this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
              x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
            )?.value;
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
            break;
        }

        this._dictionaryAPIService
          .getDictionaryContractModificationRequestReason(
            this.contractModificationRequest.dictionaryModificationTypeId,
            this.contractModificationRequest.dictionaryReimbursementTypeId,
            true
          )
          .subscribe(x => {
            this.contractModificationRequestReasonDatasource = x;
          });

        this._dictionaryAPIService
          .getDictionaryContractModificationRequestPurpose(
            this.contractModificationRequest.dictionaryModificationTypeId
          )
          .subscribe(x => {
            this.contractModificationPurposeDatasource = x;
          });

        break;

      case contractModificationsWizardSteps.ContractModification_Why:
        switch (this.contractModificationRequest.dictionaryModificationTypeId) {
          default:
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_PaymentSource;
            break;

          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id:
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_PostponePeriod;
            break;
        }
        break;

      case contractModificationsWizardSteps.ContractModification_PostponePeriod:
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_RequestPurpose;
        break;

      case contractModificationsWizardSteps.ContractModification_PaymentSource:
        if (
          this.contractModificationRequest.dictionaryReimbursementTypeId ==
          this.DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id
        ) {
          this.currentWizardStep = contractModificationsWizardSteps.ContractModification_AmountPayInAdvance;
        } else if (
          this.contractModificationRequest.dictionaryReimbursementTypeId ==
          this.DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id
        ) {
          this.mapWizardProperties();
          this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
        }
        break;

      case contractModificationsWizardSteps.ContractModification_AmountPayInAdvance:
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_RequestPurpose;
        break;

      case contractModificationsWizardSteps.ContractModification_RequestPurpose:
        this.mapWizardProperties();
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Preview;
        break;

      case contractModificationsWizardSteps.ContractModification_Preview:
        if (this.isValidWizardForm()) {
          this.saveContractModificationWizardForm();
        }
        break;
    }
  };

  previousStepHandler(currentStep: contractModificationsWizardSteps) {
    switch (currentStep) {
      case contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType:
        this._router.navigate(['requests/contract-modifications']);
        break;
      case contractModificationsWizardSteps.ContractModification_Why:
        this.currentWizardStep =
          contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
        break;

      case contractModificationsWizardSteps.ContractModification_PostponePeriod:
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Why;
        break;

      case contractModificationsWizardSteps.ContractModification_PaymentSource:
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_Why;
        break;

      case contractModificationsWizardSteps.ContractModification_AmountPayInAdvance:
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_PaymentSource;
        break;

      case contractModificationsWizardSteps.ContractModification_RequestPurpose:
        if (
          this.contractModificationRequest.dictionaryModificationTypeId ==
          this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id
        ) {
          this.currentWizardStep = contractModificationsWizardSteps.ContractModification_PostponePeriod;
        } else {
          this.currentWizardStep = contractModificationsWizardSteps.ContractModification_AmountPayInAdvance;
        }
        break;

      case contractModificationsWizardSteps.ContractModification_Preview:
        switch (this.contractModificationRequest.dictionaryModificationTypeId) {
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id:
            if (
              this.contractModificationRequest.dictionaryReimbursementTypeId ==
              this.DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id
            ) {
              this.currentWizardStep = contractModificationsWizardSteps.ContractModification_RequestPurpose;
            } else if (
              this.contractModificationRequest.dictionaryReimbursementTypeId ==
              this.DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id
            ) {
              this.currentWizardStep = contractModificationsWizardSteps.ContractModification_PaymentSource;
            }
            break;

          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id:
            this.currentWizardStep = contractModificationsWizardSteps.ContractModification_RequestPurpose;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.OTHER?.id:
            this.currentWizardStep =
              contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.COMPLAINTS?.id:
            this.currentWizardStep =
              contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.FINANCING_OFFER?.id:
            this.currentWizardStep =
              contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.CONTRACT_ASSIGNMENT?.id:
            this.currentWizardStep =
              contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
            break;
          case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.DIRECT_DEBIT?.id:
            this.currentWizardStep =
              contractModificationsWizardSteps.ContractModification_ChooseContractAndModificationType;
            break;
        }
        break;
    }
  }

  saveContractModificationWizardForm() {
    this._requestAPIService.saveContractModificationRequest(this.contractModificationRequest).subscribe(result => {
      if (result.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('contractModifications.wizard.notification.requestSaved'),
          this._translateService.instant('common.success')
        );
        this.currentWizardStep = contractModificationsWizardSteps.ContractModification_RequestSent;
      }
    });
  }

  isValidWizardForm() {
    return (
      this.contractModificationRequest &&
      this.contractModificationRequest.contractId &&
      this.contractModificationRequest.dictionaryModificationTypeId
    );
  }

  mapWizardProperties() {
    this.contractModificationRequest.contractName = this.contractsDataSource.find(
      x => x.contractId == this.contractModificationRequest.contractId
    )?.number;
    this.contractModificationRequest.dictionaryModificationTypeName = this.contractModificationRequestType.find(
      x => x.id == this.contractModificationRequest.dictionaryModificationTypeId
    )?.value;

    this.contractModificationRequest.dictionaryPaymentSourceId = this.secondQuestionFormGroup.value.answear;
    this.contractModificationRequest.dictionaryPaymentSourceName = this.paymentSourcesDatasource.find(
      x => x.id == this.contractModificationRequest.dictionaryPaymentSourceId
    )?.value;
    this.contractModificationRequest.dictionaryContractModificationRequestReasonId =
      this.firstQuestionFormGroup.value?.answear;
    const reason = this.contractModificationRequestReasonDatasource.find(
      x => x.id == this.firstQuestionFormGroup.value?.answear
    );
    if (reason?.code.toLowerCase().includes('other')) {
      this.contractModificationRequest.otherReason = this.firstQuestionFormGroup.value?.reason;
    }
    this.contractModificationRequest.dictionaryContractModificationRequestPurposeId =
      this.fourthQuestionFormGroup.value?.answear;

    switch (this.contractModificationRequest.dictionaryModificationTypeId) {
      case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id:
        this.contractModificationRequest.dictionaryReimbursementTypeName = this.reimbursementTypeDatasource.find(
          x => x.id == this.contractModificationRequest.dictionaryReimbursementTypeId
        )?.value;

        switch (this.contractModificationRequest.dictionaryReimbursementTypeId) {
          case this.DICTIONARY_REIMBURSEMENT_TYPE.PARTIAL_REIMBURSEMENT?.id:
            this.contractModificationRequest.reimbursedAmount = +this.thirdQuestionFormGroup.value.answear;
            break;

          case this.DICTIONARY_REIMBURSEMENT_TYPE.FULL_REIMBURSEMENT?.id:
            this.contractModificationRequest.reimbursedAmount =
              this.contractModificationRequestHeader.outstandingAmount;
            break;
        }
        break;

      case this.DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id:
        this.contractModificationRequest.defermentPeriodStart = this.postponedPeriodRange.start;
        this.contractModificationRequest.defermentPeriodEnd = this.postponedPeriodRange.end;
        break;
    }

    this.reasonOfRequest = this.previewReasonOfRequest();
    this.purposeOfRequest = this.previewPurposeOfRequest();
  }

  editWizardStepHandler = (wizardStep: contractModificationsWizardSteps) => {
    this.currentWizardStep = wizardStep;
  };

  redirectContractModificationRequestsHandler = () => {
    this._router.navigate(['requests/contract-modifications']);
  };

  reasonOfRequest: string;
  previewReasonOfRequest() {
    const reason = this.contractModificationRequestReasonDatasource.find(
      x => x.id == this.firstQuestionFormGroup.value?.answear
    );
    let translation: string = '';

    if (reason?.code.toLowerCase().includes('other')) {
      translation = `${this._translateService.instant('contractModifications.wizard.preview.other')}: "${this.firstQuestionFormGroup.value?.reason}"`;
    } else {
      translation = reason?.value;
    }

    return translation;
  }

  purposeOfRequest: string;
  previewPurposeOfRequest() {
    const purpose = this.contractModificationPurposeDatasource.find(
      x => x.id == this.fourthQuestionFormGroup.value?.answear
    );
    return purpose?.value;
  }

  mapPostponedPeriod(event: any) {
    if (event) {
      this.postponedPeriodRange = event;
    }
  }
}
